// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1BOS2","actions":"styles_actions__2RutX","error":"styles_error__1JhuU","message":"styles_message__3M98o"};